import { FaAt, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const contacts = [
  {
    handle: 'jossdoebler',
    url: 'https://www.linkedin.com/in/jossdoebler/',
    icon: FaLinkedinIn,
  },
  {
    handle: 'joss.doe',
    url: 'https://www.instagram.com/joss.doe/',
    icon: FaInstagram,
  },
  {
    handle: 'mail@joss-doebler.de',
    url: 'mailto:mail@joss-doebler.de',
    icon: FaAt,
  },
];

export default contacts;
